import { render, staticRenderFns } from "./subproperty-form-page.vue?vue&type=template&id=6a026c07&scoped=true&"
import script from "./subproperty-form-page.vue?vue&type=script&lang=js&"
export * from "./subproperty-form-page.vue?vue&type=script&lang=js&"
import style0 from "./subproperty-form-page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./subproperty-form-page.vue?vue&type=style&index=1&id=6a026c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a026c07",
  null
  
)

export default component.exports